import { TenantInfo } from "@/services/tenant-service/entities/TenantEntity.ts";

export class UserLoginInfo {
  guid: string;
  name: string;
  phoneNumber: string;
  email: string;
  roles: string;
  jobTitle: string;
  timeZone: string;
  language: string;
  tenantInfo: TenantInfo;
  constructor(data?: Record<string, any>) {
    this.guid = data?.guid || "";
    this.name = data?.name || "";
    this.phoneNumber = data?.phoneNumber || "";
    this.email = data?.email || "";
    this.roles = data?.roles || "";
    this.jobTitle = data?.jobTitle || "";
    this.timeZone = data?.timezone || "";
    this.language = data?.language || "";
    this.tenantInfo = new TenantInfo(data?.tenantInfo);
  }
}